module.exports = __webpack_public_path__ + "img/footer-logo-black.2746bfdd.png";